// extracted by mini-css-extract-plugin
module.exports = {"navMenu":"header-module--nav-menu--1XKy1","activeNavItem":"header-module--active-nav-item--26N0B"};